import React, { useState, useEffect, useRef } from "react";

import Header from "../components/Header";
import Footer from "../components/Footer";

import googlePlay from "../assets/images/google-store.png";
import applePlay from "../assets/images/app-store.png";

import headerBanner from "../assets/images/HeaderBanner.png";
import sellYourProject from "../assets/images/sellYourProduct.png";
import buyYourProject from "../assets/images/buyYourProject.png";

import whyChooseUs from "../assets/images/whyChooseUs.png";
import blackTick from "../assets/images/black-tick.png";

import downloadApp from "../assets/images/downloadApp.png";

import multipleUser from "../assets/images/multipleUser.png";
import createStore from "../assets/images/createStore.png";

// Import AOS

const HomePage = () => {
  // useEffect(() => {
  //   const handleScroll = () => {
  //     const scrollPosition = window.scrollY;
  //     const moveX = scrollPosition * 0.5;
  //     setScrollX(moveX);
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  const svgRef = useRef(null);
  const pathRef = useRef(null);

  useEffect(() => {
    const svg = svgRef.current;
    const path = pathRef.current;

    if (!svg || !path) return;

    const scroll = () => {
      const distance = window.scrollY;
      const totalDistance = svg.clientHeight - window.innerHeight;
      console.log(totalDistance);
      const percentage = distance / totalDistance;
      const pathLength = path.getTotalLength();

      path.style.strokeDasharray = `${pathLength}`;
      path.style.strokeDashoffset = `${pathLength * (1 - percentage)}`;
    };

    scroll();
    window.addEventListener("scroll", scroll);

    return () => {
      window.removeEventListener("scroll", scroll);
    };
  }, []);

 
  return (
    <>
      <div className="main-bg pb-5">
        <Header />
        {/* Banner Sec */}
        <div className="container header-banner bg-gradient" id="home">
          <div className="row">
            <div className="col-md-12 col-12">
              <div className="header-txt1" data-aos="fade-up">
                <h1
                  data-aos="fade-up"
                  data-aos-delay="200"
                  className="heading-texti text-center hover-scale-sm"
                >
                  Sed ut perspiciatis unde omnis iste natus <br />
                  error sit voluptatem accusantium
                </h1>
              </div>
              <div className="d-flex justify-content-center align-items-center" data-aos="zoom-in" data-aos-delay="250">
                <img src={headerBanner} className="mobile-banner-imgs hover-scale-sm" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About Us */}
      <div className="container aboutUs-main" id="about">
        <div className="text-center" data-aos="fade-up">
          <h2 className="text-black about-heading">About Bazarna</h2>
          <p className="about-desc">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod
          </p>
        </div>
        <div className="row my-2 g-4 about-cards justify-content-center">
          <div
            className="col-lg-4 col-md-6 col-12"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div className="about-card about-card--red hover-rise-sm">
              <div className="about-card__header">
                Consectetur Adipiscing Elit
              </div>
              <div className="about-card__body">
                <p>
                  Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                  accusantium doloremque site laudantium, totam rem aperiam,
                  eaque ipsa quae ab illo inventore veritatis.
                </p>
              </div>
            </div>
          </div>
          <div
            className="col-lg-4 col-md-6 col-12"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <div className="about-card about-card--green hover-rise-sm">
              <div className="about-card__header">
                Consectetur Adipiscing Elit
              </div>
              <div className="about-card__body">
                <p>
                  Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                  accusantium doloremque site laudantium, totam rem aperiam,
                  eaque ipsa quae ab illo inventore veritatis.
                </p>
              </div>
            </div>
          </div>
          <div
            className="col-lg-4 col-md-6 col-12"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            <div className="about-card about-card--yellow hover-rise-sm">
              <div className="about-card__header">
                Consectetur Adipiscing Elit
              </div>
              <div className="about-card__body">
                <p>
                  Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                  accusantium doloremque site laudantium, totam rem aperiam,
                  eaque ipsa quae ab illo inventore veritatis.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Employee App Section */}
      <div className="container py-5 employee-app-section" id="employeeApp">
        <div className="row align-items-center">
          {/* Left Column - Text Content */}
          <div
            className="col-lg-6 position-relative"
            data-aos="fade-right"
            data-aos-delay="100"
          >
            <div className="employee-img">
              <div className="employee-large-phone">
                <img
                  src={sellYourProject}
                  alt="Employee App Yellow"
                  className="phone-mockup-large hover-scale-sm"
                />
              </div>
            </div>
          </div>

          {/* Right Column - Large Yellow Phone */}
          <div
            className="col-lg-6 employee-app-section-right-column"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <div className="app-section-content">
              <h2 className="app-section-title hover-scale-sm">Sell Your Project</h2>
              <p className="app-section-detail">
                But I must explain to you how all this mistaken <br />
                idea of denouncing pleasure.
              </p>
              <p className="app-section-description">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem 
                <br className="br" />
                 accusantium doloremque laudantium, totam rembe aperiam, <br className="br" />
                eaque ipsa quae ab illo inventore veritatis eat quai architecto
                <br className="br" />
                beatae expound the actual teachings of the great.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Company App Section */}
      <div className="container py-5 employee-app-section" id="companyApp">
        <div className="row align-items-center">
          {/* Left Column */}
          <div
            className="col-lg-6 company-app-section-left-column"
            data-aos="fade-right"
            data-aos-delay="100"
          >
            <h2 className="app-section-title">Buy Your Project</h2>
            <p className="app-section-detail">
              But I must explain to you how all this mistaken <br />
              idea of denouncing pleasure.
            </p>
            <p className="app-section-description">
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              <br />
              accusantium doloremque laudantium, totam rembe aperiam, <br />
              eaque ipsa quae ab illo inventore veritatis eat quai architecto
              <br />
              beatae expound the actual teachings of the great.
            </p>
          </div>

          {/* Right Column */}
          <div
            className="col-lg-6 position-relative"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <div className="company-img">
              <div className="employee-large-phone">
                <img
                  src={buyYourProject}
                  alt="Employee App Yellow"
                  className="phone-mockup-large-blue hover-scale-sm"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Why Choose Us */}
      <div className="container my-5" id="whyChooseUs">
        <div className="row">
          <div className="col-md-6 d-flex justify-content-center align-items-center" data-aos="fade-right">
            <div>
              <img src={whyChooseUs} className="whyChooseUs-img hover-scale-sm" alt="" />
            </div>
          </div>
          <div className="col-md-6" data-aos="fade-left" data-aos-delay="150">
            <div className="why-choose-us-content">
              <h2 className="app-section-title hover-scale-sm">Why Choose Us</h2>
              <p className="app-section-detail">
                At vero eos et accusamus et iusto odio choose <br />
                dignissimos ducimus qui blanditiis
              </p>
              <p className="app-section-description">
                Sed ut perspiatis unde omnis iste natus error sit voluptatem
                accusant <br />
                ium doloremque site laudantium, totam aperiam, eaque ipsa quae
                ab <br />
                illo inventore veritatis voluptas assumenda est.
              </p>
              <ul className="whyChooseUs-unOrder-list">
                <li className="whyChooseUs-list d-flex hover-rise-sm" data-aos="zoom-in" data-aos-delay="100">
                  <div className="black-tick d-flex align-items-center justify-content-center rounded-pill">
                    <img src={blackTick} alt="" className="hover-scale-sm" />
                  </div>
                  <span>
                    Accusamus et iusto odio choose dignissimos ducimus qui
                  </span>
                </li>
                <li className="whyChooseUs-list d-flex hover-rise-sm" data-aos="zoom-in" data-aos-delay="150">
                  <div className="black-tick d-flex align-items-center justify-content-center rounded-pill">
                    <img src={blackTick} alt="" className="hover-scale-sm" />
                  </div>
                  <span>
                    impedit minus id quod maxime placeat facere possimus
                  </span>
                </li>
                <li className="whyChooseUs-list d-flex hover-rise-sm" data-aos="zoom-in" data-aos-delay="200">
                  <div className="black-tick d-flex align-items-center justify-content-center rounded-pill">
                    <img src={blackTick} alt="" className="hover-scale-sm" />
                  </div>
                  <span>
                    accusamus et iusto odio choose dignissimos ducimus qui
                  </span>
                </li>
                <li className="whyChooseUs-list d-flex hover-rise-sm" data-aos="zoom-in" data-aos-delay="250">
                  <div className="black-tick d-flex align-items-center justify-content-center rounded-pill">
                    <img src={blackTick} alt="" className="hover-scale-sm" />
                  </div>
                  <span>
                    accusamus et iusto odio choose dignissimos ducimus qui
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* App Featured */}
      <div className="container my-5" id="featured">
        <div className="row">
          <div className="col-md-12">
            <h2 className="app-section-title text-center hover-scale-sm w-100" data-aos="fade-up">App Featured</h2>
            <p className="app-section-detail text-center" data-aos="fade-up">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod
            </p>
          </div>
          <div className="col-md-3" data-aos="zoom-in" data-aos-delay="100">
            <div className="app-featured-box hover-rise-sm">
              <img src={multipleUser} alt="" className="app-featured-img hover-scale-sm" />
              <h3 className="app-featured-title">Multiple Users</h3>
              <p className="app-featured-detail text-center">
                Sed ut perspiatis unde omnis iste <br />
                natus error voluptatem accusant <br />
                ium doloremque site laudan.
              </p>
            </div>
          </div>
          <div className="col-md-3" data-aos="zoom-in" data-aos-delay="150">
            <div className="app-featured-box hover-rise-sm">
              <img src={createStore} alt="" className="app-featured-img hover-scale-sm" />
              <h3 className="app-featured-title">Create Store</h3>
              <p className="app-featured-detail text-center">
                Sed ut perspiatis unde omnis iste <br />
                natus error voluptatem accusant <br />
                ium doloremque site laudan.
              </p>
            </div>
          </div>
          <div className="col-md-3" data-aos="zoom-in" data-aos-delay="200">
            <div className="app-featured-box hover-rise-sm">
              <img src={createStore} alt="" className="app-featured-img hover-scale-sm" />
              <h3 className="app-featured-title">Add Product</h3>
              <p className="app-featured-detail text-center">
                Sed ut perspiatis unde omnis iste <br />
                natus error voluptatem accusant <br />
                ium doloremque site laudan.
              </p>
            </div>
          </div>
          <div className="col-md-3" data-aos="zoom-in" data-aos-delay="250">
            <div className="app-featured-box hover-rise-sm">
              <img src={createStore} alt="" className="app-featured-img hover-scale-sm" />
              <h3 className="app-featured-title">Sell Product</h3>
              <p className="app-featured-detail text-center">
                Sed ut perspiatis unde omnis iste <br />
                natus error voluptatem accusant <br />
                ium doloremque site laudan.
              </p>
            </div>
          </div>
          <div className="col-md-3" data-aos="zoom-in" data-aos-delay="300">
            <div className="app-featured-box mt-0 hover-rise-sm">
              <img src={multipleUser} alt="" className="app-featured-img hover-scale-sm" />
              <h3 className="app-featured-title">Reasonable Earning</h3>
              <p className="app-featured-detail text-center">
                Sed ut perspiatis unde omnis iste <br />
                natus error voluptatem accusant <br />
                ium doloremque site laudan.
              </p>
            </div>
          </div>
          <div className="col-md-3" data-aos="zoom-in" data-aos-delay="350">
            <div className="app-featured-box mt-0 hover-rise-sm">
              <img src={createStore} alt="" className="app-featured-img hover-scale-sm" />
              <h3 className="app-featured-title">Get Gifted Item</h3>
              <p className="app-featured-detail text-center">
                Sed ut perspiatis unde omnis iste <br />
                natus error voluptatem accusant <br />
                ium doloremque site laudan.
              </p>
            </div>
          </div>
          <div className="col-md-3" data-aos="zoom-in" data-aos-delay="400">
            <div className="app-featured-box mt-0 hover-rise-sm">
              <img src={createStore} alt="" className="app-featured-img hover-scale-sm" />
              <h3 className="app-featured-title">Rating & Reviews</h3>
              <p className="app-featured-detail text-center">
                Sed ut perspiatis unde omnis iste <br />
                natus error voluptatem accusant <br />
                ium doloremque site laudan.
              </p>
            </div>
          </div>
          <div className="col-md-3" data-aos="zoom-in" data-aos-delay="450">
            <div className="app-featured-box mt-0 hover-rise-sm">
              <img src={createStore} alt="" className="app-featured-img hover-scale-sm" />
              <h3 className="app-featured-title">Sell Product</h3>
              <p className="app-featured-detail text-center">
                Sed ut perspiatis unde omnis iste <br />
                natus error voluptatem accusant <br />
                ium doloremque site laudan.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Download our App */}
      <div className="container download-App-main" id="downloadApp" data-aos="fade-up">
        <img
          src={downloadApp}
          className="download-img-section img-fluid"
          alt=""
        />
        <div className="row downloadApp">
          <div
            className="col-md-6 offset-md-6 text-white d-flex flex-column justify-content-center"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <p className="appDown-section-detail mb-2">Bazarna help to</p>

            <h1 className="appDown-section-title hover-scale-sm">Sell Your Products & Earn</h1>
            <p className="appDown-section-description">
              Sed ut perspiatis unde omnis iste natus error <br />
              voluptatem accusant ium doloremque site laudan.
            </p>

            <div
              className="btn-download-app"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <a
                href="https://apps.apple.com/ae/app/digits-hire-car/id6747331842"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={googlePlay}
                  style={{
                    width: "186px",
                    height: "58px",
                    marginRight: "10px",
                  }}
                  className="hover-scale-sm"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.devicebee.digits"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={applePlay}
                  style={{ width: "197px", height: "58px" }}
                  className="hover-scale-sm"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default HomePage;
